const isChatLoaded = (state: AnyFixMe) => state.unifiedChat.isChatLoaded;
const isChatVisible = (state: AnyFixMe) => state.unifiedChat.isVisible;

export { isChatLoaded, isChatVisible };
